import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateTenantListQuery, useUpdateTenantQueries } from "@/queries/query-tenant";

export const useDeleteTenants = () => {
  const updateTenantQueries = useUpdateTenantQueries();
  const invalidateTenantListQuery = useInvalidateTenantListQuery();
  return useMutationWithErrorHandler(async (tenantIds: string[]) => {
    const promises = tenantIds.map(async (tenantId) => {
      await getRanaApiV1().TenantsApi.tenantDestroy({ tenantId });
      updateTenantQueries(tenantId, null);
    });
    await Promise.all(promises);
    invalidateTenantListQuery();
  });
};
